import React, { useEffect, useState, useContext } from 'react';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { AuthContext } from '../context/AuthContext'
import { useHttp } from '../hooks/http.hook'
import Dropdown from 'react-dropdown';
import { styled } from '@mui/material/styles';

import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import 'react-dropdown/style.css';
import DraftEditor from './Editor/DraftEditor';
import CustomToolbar from '../components/CustomToolbar';

import ReactQuill, { Quill } from 'react-quill';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Stack } from '@mui/material';
function preventDefault(event) {
    event.preventDefault();
}


const Font = Quill.import('formats/font'); // class-based атрибутор
Font.whitelist = [
    'BankGothic-Regular',
    'PTSans',
    'Calibri',
    'Calibri-bold',
    'Sans-Serif'
];
Quill.register(Font, true);
const modules = {
    toolbar: {
        container: '#editor-toolbar',
        // handlers: { } // при желании сюда можно добавить свои обработчики
    },
};

const formats = [
    'header',
    'font',
    'size',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
    'video',
    'color',
    'background', // добавили фоны
];
export default function ReferencePostCreateComponents(props) {

    const { token, logout } = useContext(AuthContext)
    const [title, setTitle] = useState(null)
    const [text, setText] = useState(null)
    const [more, setMore] = useState(null)
    const [preview, setPreview] = useState('')
    const [photo, setPhoto] = useState('')
    const [reload, setReload] = useState(null)
    const [categoryRows, setCategoryRows] = useState(new Map())
    const [options, setOptions] = useState([])
    const [valueDropDown, setValueDropDown] = useState(null)
    const quillRef = React.useRef(null);
    const { loading, request, error, clearError } = useHttp()

    const uploadImageIMG = async (file) => {
        const fmData = new FormData();
        const config = {
            headers: { "content-type": "multipart/form-data", "authorization": `Bearer ${token}` },
            onUploadProgress: event => {
                const percent = Math.floor((event.loaded / event.total) * 100);

            }
        };
        fmData.append("file", file.target.files[0]);
        try {
            const res = await axios.post(
                "/api/files/download",
                fmData,
                config
            );

            // onSuccess("Ok");
            setPhoto(res.data.filename)
        } catch (err) {
            setPhoto('')
            console.log("Eroor: ", err);
            const error = new Error("Some error");
            // onError({ err });
        }
    };

    const uploadImagePreview = async (file) => {
        const fmData = new FormData();
        const config = {
            headers: { "content-type": "multipart/form-data", "authorization": `Bearer ${token}` },
            onUploadProgress: event => {
                const percent = Math.floor((event.loaded / event.total) * 100);

            }
        };
        fmData.append("file", file.target.files[0]);
        try {
            const res = await axios.post(
                "/api/files/download",
                fmData,
                config
            );

            // onSuccess("Ok");
            setPreview(res.data.filename)
        } catch (err) {
            setPreview('')
            console.log("Eroor: ", err);
            const error = new Error("Some error");
            // onError({ err });
        }
    };

    const getMaking = async () => {
        const datat = await request('/api/references_groups/', 'GET', null, {
            authorization: `${token}`
        }
        )
        if (datat) {
            let bufRows = []
            let bufRows2 = []
            //console.log(datat)
            for (let row of datat) {
                bufRows.push({ 'label': row.name, 'value': row.id })
                bufRows2.push({ 'name': row.name, 'id': row.id })
            }
            setCategoryRows(new Map(bufRows2.map(item => [item.id, item.name])))
            setOptions(bufRows)

        }
    }

    React.useEffect(() => {
        if (props?.select) {
            //console.log(props?.select)
            setTitle(props?.select?.name ?? '')
            setText(props?.select?.text ?? '')
            setMore(props?.select?.description ?? '')
            setPhoto(props?.select?.img ?? '')
            console.log("preview", props?.select?.preview)
            setPreview(props?.select?.preview ?? '')
            setValueDropDown({ value: props.select.references_groups_id, label: categoryRows.get(props.select.references_groups_id) })

        }

    }, [props, categoryRows])

    React.useEffect(() => {
        getMaking()
    }, [])

    React.useEffect(() => {
        if (reload) {
            props.update()
            setTitle('')
            setText('')
            setMore('')
            setPhoto('')
            setPreview('')
            setReload(null)

        }
    }, [reload])

    useEffect(() => {
        console.log("select", valueDropDown)
    }, [valueDropDown])

    const updateRow = async () => {
        if (props?.select && (props?.select?.text != text || props?.select?.name != title || props?.select?.img != photo)) {
            let data
            if (more) {
                data = await request(`/api/references_posts/${props.select.id}`, 'PUT', { text: text, name: title, img: photo, references_groups_id: valueDropDown.value }, {
                    authorization: `${token}`
                })
            } else {
                data = await request(`/api/references_posts/${props.select.id}`, 'PUT', { text: text, name: title, img: photo, references_groups_id: valueDropDown.value }, {
                    authorization: `${token}`
                })
            }
            if (data) {
                setReload(1)
            }
        }

    }

    const createRow = async () => {
        if (text && title) {
            const data = await request(`/api/references_posts/`, 'POST', { text: text, name: title, img: photo, references_groups_id: valueDropDown.value }, {
                authorization: `${token}`
            })
            if (data) {
                setReload(1)
            }
        }

    }
    const deleteRow = async () => {
        if (text && title && props.select) {
            const data = await request(`/api/references_posts/${props.select.id}`, 'DELETE', null, {
                authorization: `${token}`
            })
            setReload(1)
        }

    }
    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });
    // useEffect(()=>{
    //     //console.log((props?.select?.text!=text && props?.select?.name!=title))
    // },[text, title])

    return (
        <React.Fragment>
            <Grid container direction="column" spacing={2} sx={{ width: "100%" }}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        id="TitleTextField"
                        // label={title?"Заголовок":""
                        variant="standard"
                        placeholder='Заголовок'
                        // disabled={props?.select ? "" : "1"}
                        value={title}
                        onChange={(e) => { setTitle(e.target.value) }} />
                </Grid>
                <Grid item xs={12}>
                    <CustomToolbar />
                    {/* <TextField
                        fullWidth
                        id="TextTextField"
                        // label={text?"Текст": ""}
                        variant="standard"
                        placeholder='Текст'
                        // translate='yes'
                        // disabled={props?.select ? "" : "1"}
                        value={text}
                        onChange={(e) => { setText(e.target.value) }} /> */}
                    <ReactQuill theme="snow" ref={quillRef} modules={modules} formats={formats} value={text} onChange={setText} />
                </Grid>
                <Grid item xs={12}>
                    {photo != '' &&
                        <Stack direction="row" spacing={2}>
                            <Button variant="outlined" color="error" startIcon={<DeleteIcon />} onClick={() => setPhoto('')}>
                                Удалить
                            </Button>
                            <img style={{ width: "150px" }} src={photo ?? ''}></img>
                        </Stack>
                    }
                    {photo == '' &&
                        <Button
                            component="label"
                            role={undefined}
                            variant="contained"
                            tabIndex={-1}
                            startIcon={<CloudUploadIcon />}
                        >
                            Загрузить изображение
                            <VisuallyHiddenInput type="file" onChange={uploadImageIMG} accept=".png" />
                        </Button>
                    }
                </Grid>


                <Grid item xs={12}>
                    <Dropdown
                        options={options}
                        // disabled={props?.select ? "" : "1"}
                        value={valueDropDown}
                        onChange={(e) => setValueDropDown(e)}
                        placeholder="Выберите категорию" />
                </Grid>
                <Grid item xs={12}>
                    <Stack direction="row" spacing={1} flexWrap="wrap">
                        <Button variant="contained"
                            onClick={updateRow}
                            disabled={(props?.select && (props?.select?.text != text || props?.select?.img != photo || props?.select?.name != title)) ? "" : "1"}>Редактировать</Button>
                        <Button variant="contained"
                            onClick={createRow}
                        >Добавить</Button>
                        <Button variant="contained"
                            color="error"
                            onClick={deleteRow}
                            disabled={(props?.select) ? "" : "1"}
                        ><DeleteForeverIcon></DeleteForeverIcon></Button>
                    </Stack>
                </Grid>
            </Grid>

        </React.Fragment>
    );
}

